import { useCallback } from "react"
import { useSelector } from "react-redux"
import { Box } from "@mui/material"
import { RootState } from "../../../../store/store"
import { formatAmount } from "../../../../utils/formatters"
import { RUBLE } from "../../../../utils/constants"
import { useGetUserInfo } from "../../../../api/hooks/useGetUserInfo"
import { validateAmount } from "../../../../components/AmountInput/utils/utils"
import UIIcon from "../../../../components/UIIcon"
import {
  Amount,
  BottomContainer,
  ContentContainer,
  ContinueButton,
  DetailLabel,
  DetailValue,
  MerchantBrandName,
  TitleContainer,
  TopContainer,
} from "../styled"

interface DynamicPaymentProps {
  onPay: (amount: number) => void
}

const DynamicPayment = ({ onPay }: DynamicPaymentProps) => {
  const qrcInfo = useSelector((state: RootState) => state.c2bPayment.qrcInfo)
  const { data: userInfo } = useGetUserInfo()

  const availableBalance = userInfo?.balance.availableAmount || 0
  const availableWithdraw = userInfo?.availableWithdraw || 0
  const buttonDisabled =
    !qrcInfo?.amount ||
    validateAmount(qrcInfo?.amount.toString(), availableWithdraw, availableBalance).result

  const handlePay = useCallback(() => {
    if (qrcInfo?.qrcId && qrcInfo?.amount) {
      onPay(qrcInfo.amount)
    }
  }, [onPay, qrcInfo?.qrcId, qrcInfo?.amount])

  return (
    <ContentContainer>
      <TopContainer>
        <MerchantBrandName>
          {qrcInfo?.merchantBrandName}
        </MerchantBrandName>
        <Amount>
          {formatAmount(qrcInfo?.amount || 0)} {RUBLE}
        </Amount>
        <DetailLabel>Без комиссии</DetailLabel>
        <Box sx={TitleContainer}>
          <DetailLabel>С баланса:</DetailLabel>
          <DetailValue>
            {formatAmount(availableBalance)} {RUBLE}
          </DetailValue>
        </Box>
        <DetailLabel>Назначение платежа</DetailLabel>
        <DetailValue>{qrcInfo?.description}</DetailValue>
      </TopContainer>
      <BottomContainer>
        <UIIcon iconName="sbpExtIcon" size={64} />
        <ContinueButton
          variant="contained"
          disabled={buttonDisabled}
          onClick={handlePay}
          data-test-id="dynamic-payment-submit"
        >
          Оплатить
        </ContinueButton>
      </BottomContainer>
    </ContentContainer>
  )
}

export default DynamicPayment
